/**
 * Work Orders / job costing (Phase 1). Set to true to re-enable routes, linking UI, and ledger sync.
 * Implementation files remain in the repo when disabled.
 */
export const ENABLE_WORK_ORDERS = false;
